import { Suspense, lazy, useEffect, useState } from "react";
import "./styles/global.scss";
import Header from "./components/Header/Header";
import Hero from "./components/Hero/Hero";
import Overview from "./components/Overview/Overview";
import How from "./components/How/How";
import Clinical from "./components/Clinical/Clinical";
import Information from "./components/Information/Information";
import Footer from "./components/Footer/Footer";
import ProductShowcase from "./components/ProductShowcase/ProductShowcase";
import useReferralTracking from "./hooks/useReferralTracking";

const AdminPanel = lazy(() => import("./components/Admin/AdminPanel"));

function PublicSite() {
	useReferralTracking();

	return (
		<>
			<a href="#main" className="skip-link">
				Skip to content
			</a>
			<Header />
			<Hero />
			<ProductShowcase />
			<Overview />
			<Information />
			<How />
			<Clinical />
			<Footer />
		</>
	);
}

function useIsAdminRoute() {
	const [isAdmin, setIsAdmin] = useState(() => window.location.hash === "#admin");

	useEffect(() => {
		const onHashChange = () => setIsAdmin(window.location.hash === "#admin");
		window.addEventListener("hashchange", onHashChange);
		return () => window.removeEventListener("hashchange", onHashChange);
	}, []);

	return isAdmin;
}

function App() {
	const isAdminRoute = useIsAdminRoute();

	if (isAdminRoute) {
		return (
			<Suspense fallback={null}>
				<AdminPanel />
			</Suspense>
		);
	}

	return <PublicSite />;
}

export default App;
